import { initForms } from './forms';

export function setupSubmitListener(form: HTMLFormElement): void {
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData = new FormData(form);

    // Get the submitter button (if available) to check for formaction attribute
    const submitter = (e as SubmitEvent).submitter as HTMLButtonElement | HTMLInputElement | null;
    const action =
      submitter?.getAttribute('formaction') || form.getAttribute('action') || location.href;
    const method = submitter?.getAttribute('formmethod') || form.getAttribute('method') || 'POST';

    fetch(action, {
      method: method,
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(async (response) => {
        if (response.redirected) {
          window.location.href = response.url;
          return null;
        } else if (response.ok) {
          return response.text();
        } else {
          throw new Error('Something went wrong with the request');
        }
      })
      .then((html) => {
        if (html) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const newContent = tempDiv.firstElementChild as HTMLElement;

          if (newContent && form.parentNode) {
            form.parentNode.replaceChild(newContent, form);

            if (newContent instanceof HTMLFormElement) {
              setupSubmitListener(newContent);
            } else {
              const nestedForm = newContent.querySelector<HTMLFormElement>('form');
              if (nestedForm) {
                setupSubmitListener(nestedForm);
              }
            }
            initForms(newContent);

            // Dispatch custom event to notify that form was replaced
            const formReplacedEvent = new CustomEvent('form-replaced', {
              detail: { container: newContent },
              bubbles: true,
            });
            newContent.dispatchEvent(formReplacedEvent);

            // Scroll to first validation error if any
            const firstInvalidElement = newContent.querySelector('.is-invalid');
            if (firstInvalidElement) {
              firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Fetch error:', error);
      });
  });
}

export function initFetchForms(): void {
  const forms = document.querySelectorAll<HTMLFormElement>('.js-fetch-form');
  forms.forEach((form) => setupSubmitListener(form));
}
